export default () => {
  const { status, data } = useAuth();
  return computed(() => status.value === 'authenticated' && !data.value?.error);
};
